import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { noop } from 'svelte/internal';
import { getUrl } from './util';
import { initializeApp } from 'firebase/app';

export const api = {
  account: {
    createSubs: {
      url: getUrl('createSub'),
    },
    getAccount: {
      url: getUrl('getAccount'),
    },
    getBalance: {
      url: getUrl('getBalance'),
    },
    getSubs: {
      url: getUrl('getSubs'),
    },
    highlights: {
      url: getUrl('highlights'),
    },
  },
  auth: {
    update: {
      url: getUrl('authUserUpdate'),
    },
    register: {
      url: getUrl('register'),
    },
  },
  checkout: {
    checkout: {
      url: getUrl('checkout'),
    },
    closeout: {
      url: getUrl('closeout'),
    },
    transact: {
      url: getUrl('transact'),
    },
  },
  components: {
    getManifest: {
      url: getUrl('getManifest'),
    },
  },
  dashboard: {
    highlights: {
      url: getUrl('dashboardHighlights'),
    },
  },
  forms: {
    add: {
      url: getUrl('createForm'),
    },
    delete: {
      url: getUrl('deleteForm'),
    },
    edit: {
      url: getUrl('editForm'),
    },
    getFormForSite: {
      url: getUrl('getForms'),
    },
    getAllForms: {
      url: getUrl('getAllForms'),
    },
    powerUpForm: {
      url: getUrl('powerUpForm'),
    },
    view: {
      url: getUrl('getForm'),
    },
    url: getUrl('getForms'),
  },
  sites: {
    first: {
      url: getUrl('createFirstSite'),
    },
    add: {
      url: getUrl('createSite'),
    },
    delete: {
      url: getUrl('deleteSite'),
    },
    edit: {
      url: getUrl('editSite'),
    },
    view: {
      url: getUrl('getSite'),
    },
    url: getUrl('getSites'),
  },
  submissions: {
    url: getUrl('getSubmissions'),
    delete: {
      url: getUrl('deleteSubmission'),
    },
  },
};

export const defaults = {
  guestAccountLabel: 'Guest User',
  // v2
  formUrl: 'https://wf.logi.cloud/',
  // v1
  // formUrl: 'https://forms.webforma.io/forms/',
  // formUrl: 'http://localhost:10004/',
  cdnUrl: 'https://cdn.webforma.io',
};

export const firebaseConfig = {
  apiKey: 'AIzaSyAEpDvo31Wa9qrnvf1bVsALJt_GGoKYo7w',
  authDomain: "webforma-blue-cmpjb.firebaseapp.com",
  databaseURL: 'https://webforma-blue-cmpjb-default-rtdb.firebaseio.com',
  projectId: 'webforma-blue-cmpjb',
  storageBucket: 'webforma-blue-cmpjb.appspot.com',
  messagingSenderId: '921257096193',
  appId: '1:921257096193:web:248aca91d20203e4dffc00',
  measurementId: 'G-XGWXXF8NSV',
};

export const firebaseInstance = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseInstance);

if (window.location.hostname === 'localhost') {
  console.info('::::::::::::::', 'Using Auth Emulator', '::::::::::::::');
  connectAuthEmulator(auth, 'http://localhost:9099');
}

export const pages = {
  account: {
    description: 'View account data',
    url: '/account',
    list: {
      url: '/accounts',
      description: 'Account List',
    },
    // account overview is same as account list
    overview: {
      url: '/accounts',
      description: 'Account Overview',
    },
  },
  auth: {
    logout: {
      description: 'Logout of Webforma',
      url: '/logout',
    },
  },
  chargeups: {
    siteTitle: 'Chargeup my account',
    success: {
      url: '/chargeup/success',
    },
    description: 'Add Credits to your Webforma Account',
    url: '/chargeup',
  },
  components: {
    description: 'Generate Webforma Components',
    url: '/components',
  },
  dashboard: {
    description: 'View the Account Dashboard',
    url: '/',
    dashboard: {
      url: '/dashboard',
    },
  },
  entry: {
    description: 'Authenticate or Link this session with your Webforma Account',
    url: '/enter',
    link: {
      url: '/enter/link',
      verify: {
        url: '/enter/link/verify',
      },
    },
    verify: {
      url: '/enter/verify',
    },
    waiting: {
      url: '/enter/waiting',
    },
    welcome: {
      url: '/enter/welcome',
    },
  },
  error: {
    redirect: {
      url: '/errors/redirect',
      description: 'Failed to redirect to the correct page',
    },
  },
  forms: {
    add: {
      url: '/forms/add',
    },
    delete: {
      url: '/forms/delete',
    },
    edit: {
      url: '/forms/edit',
    },
    overview: {
      url: '/forms/view',
    },
    url: '/forms',
  },
  login: {
    url: '/login',
  },
  logout: {
    description: 'De-authenticate your Webforma Account',
    url: '/logout',
  },
  powerups: {
    sendEmail: {
      url: '/powerups/send-email',
    },
    url: '/powerups',
  },
  settings: {
    url: '/settings',
  },
  sites: {
    add: {
      description: 'Add a new site to your account',
      url: '/sites/add',
    },
    delete: {
      description: 'Delete site',
      url: '/sites/delete',
    },
    edit: {
      description: 'Edit site',
      url: '/sites/edit',
    },
    first: {
      description: 'Add a new site to your account',
      url: '/sites/first',
    },
    details: {
      url: '/sites/view',
    },
    overview: {
      url: '/sites/view',
    },
    url: '/sites',
  },
  stats: {
    url: '/stats',
  },
  web: {
    url: '/',
  },
};

export const redirectors = {
  'account.dashboard': {
    params: [],
    target: pages.dashboard.url,
  },
  'account.index': {
    params: [],
    target: pages.account.url,
  },
  'sites.overview': {
    params: ['sid'],
    target: pages.sites.overview.url,
  },
};

export const userStoreKey = 'user';

export function handleRedirect(from, data = {}, goto = noop) {
  const exists = redirectors[from];
  let params = null;
  if (exists && exists.params) {
    params = exists.params.map((paramName) => data[paramName]);
    goto(exists.target, ...params);
  }
  return !!exists;
}

export const inputTypes = [
  'number',
  'date',
  'email',
  '----------------',
  'button',
  'checkbox',
  'color',
  'date',
  'datetime-local',
  'email',
  'file',
  'hidden',
  'image',
  'month',
  'number',
  'password',
  'radio',
  'range',
  'reset',
  'search',
  'submit',
  'tel',
  'text',
  'time',
  'url',
  'week',
];
